module.exports = __webpack_public_path__ + "static/media/walkies.1eec92b7.png";